import { __assign } from "tslib";
import React from 'react';
import { CLOSE_ICON } from '@marvelapp/theme';
import { Box, Icon, Tooltip } from '@marvelapp/ui';
import Button from './Button';
export default function CancelButton(props) {
    return (React.createElement(Box, { marginRight: 1 },
        React.createElement(Tooltip, { content: "Cancel editing", display: "block" },
            React.createElement(Button, __assign({ alignItems: "center", display: "flex", hoverColor: "red", justifyContent: "center", marginRight: 0, width: 26 }, props),
                React.createElement(Icon, { display: "block", height: 20, paths: CLOSE_ICON, width: 20 })))));
}
